import { faWrench, faTools, faCar } from "@fortawesome/free-solid-svg-icons";

export const highlightsData = {
  "motor-revision-356-911-964-993": {
    items: [
      "Engine overhaul",
      "Bodywork restoration",
      "Interior customization",
    ],
    icon: faWrench,
  },
  "engine-restoration": {
    items: [
      "Complete engine restoration",
      "Porsche engine tuning",
      "Precision machining",
    ],
    icon: faTools,
  },
  customization: {
    items: [
      "Custom interiors",
      "Performance upgrades",
      "Exhaust modifications",
    ],
    icon: faCar,
  },
  // Add more configurations as needed
};
